'use strict';

import angular from 'angular';


export default function($log, $scope, entityService) {
	'ngInject';

	var vm = this;

	$scope.entityData = entityService.data;

	$scope.$watch('entityData', function(newValue) {
		vm.data = newValue;
	}, true);
}
